import ImportJobsTable from "./components/ImportJobsTable.jsx";

export default function ImportJobsTab() {
  return <ImportJobsTable />;
}
